
export function showReleaseNotesModal() {
	 window.location.hash='updates'
}




// WEBPACK FOOTER //
// ./src/utils/showReleaseNotesModal.js